export const materialMasterExcelUploadS3Link =
  "api/v1/file-system/get-s3-upload-url/material-master-import";
export const materialMasterBulkUploadApiLink = "api/v1/master-data/materials/excel";
